import React from 'react';
import {Snackbar} from '@material-ui/core';
import {withUsePostEndpoint} from 'hooks/usePostEndpoint';
import {errorDataHelper} from 'hooks';
import {LoadingPage} from 'components';

const snackbarPosition = {vertical: 'top', horizontal: 'center'};
const errorMessage = error =>
    process.env.NODE_ENV === 'production'
        ? 'Oops! Our wires got crossed. Please refresh the page and try again.'
        : `Oops! Our wires got crossed. Please refresh the page and try again. [${error}]`;

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error(
            '[ErrorBoundary] Caught an unhandled error',
            error,
            errorInfo
        );
        this.props.postEndpoint(
            errorDataHelper({
                feedback_text: `[AUTO GENERATED][ERROR BOUNDARY - UNCAUGHT ERROR]: ${JSON.stringify(
                    {error, errorInfo},
                    null,
                    2
                )}`,
            })
        );
    }

    render() {
        if (this.state.hasError) {
            if (this.props.postEndpointInProgress) {
                return <LoadingPage />;
            }
            return (
                <Snackbar
                    anchorOrigin={snackbarPosition}
                    open
                    message={errorMessage(this.state.error)}
                    key='top-center'
                />
            );
        }
        return this.props.children;
    }
}

export default withUsePostEndpoint('/user/feedback', ErrorBoundary);
